var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHackathon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 200,
    viewBox: "0 0 75 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1326_1110)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1326_1110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 188V12C0 5.37258 5.37259 0 12 0H63C69.6274 0 75 5.3726 75 12V165.184C75 167.771 74.1643 170.288 72.6175 172.361L55.5923 195.177C53.3273 198.212 49.7622 200 45.9748 200H12C5.37258 200 0 194.627 0 188Z",
    fill: "#282828",
    fillOpacity: 0.05,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 188V12C0 5.37258 5.37259 0 12 0H63C69.6274 0 75 5.3726 75 12V165.184C75 167.771 74.1643 170.288 72.6175 172.361L55.5923 195.177C53.3273 198.212 49.7622 200 45.9748 200H12C5.37258 200 0 194.627 0 188Z",
    fill: "url(#paint0_linear_1326_1110)",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 188V12C0.5 5.64873 5.64873 0.5 12 0.5H63C69.3513 0.5 74.5 5.64874 74.5 12V165.184C74.5 167.663 73.6991 170.075 72.2168 172.062L55.1916 194.878C53.0209 197.787 49.6044 199.5 45.9748 199.5H12C5.64872 199.5 0.5 194.351 0.5 188Z",
    stroke: "url(#paint1_linear_1326_1110)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.674 154.872L27.674 157.392L35.102 157.392L35.102 166.632L27.674 166.632L27.674 169.152L44.834 169.152L44.834 166.632L37.442 166.632L37.442 157.392L44.834 157.392L44.834 154.872L27.674 154.872ZM36.212 153.18L36.212 150.75C34.544 150.75 33.446 149.64 33.446 147.198C33.446 144.804 34.808 143.304 36.986 143.304L37.292 143.304L37.292 148.41C37.292 151.602 38.786 153.57 41.204 153.57C43.598 153.57 45.194 151.644 45.194 148.752C45.194 145.962 43.712 143.946 41.276 143.304L44.834 143.304L44.834 140.874L36.986 140.874C33.392 140.874 31.244 143.238 31.244 147.156C31.244 150.858 33.17 153.18 36.212 153.18ZM39.332 143.304L39.698 143.304C41.672 143.304 43.076 145.29 43.076 148.098C43.076 150.078 42.38 151.17 41.12 151.17C39.956 151.17 39.332 150.222 39.332 148.434L39.332 143.304ZM38.216 137.117C35.258 137.117 33.44 135.575 33.44 133.073C33.44 130.877 34.844 129.713 36.59 129.395L36.59 126.965C33.584 127.355 31.244 129.527 31.244 133.079C31.244 136.955 34.034 139.547 38.216 139.547C42.398 139.547 45.194 136.955 45.194 133.079C45.194 129.527 42.854 127.361 39.848 126.965L39.848 129.395C41.594 129.719 42.998 130.883 42.998 133.073C42.998 135.575 41.174 137.117 38.216 137.117ZM31.604 113.744L31.604 116.864L37.484 123.158L27.074 123.158L27.074 125.588L44.834 125.588L44.834 123.158L39.356 123.158L44.834 116.588L44.834 113.108L38.366 121.118L31.604 113.744ZM36.212 113.048L36.212 110.618C34.544 110.618 33.446 109.508 33.446 107.066C33.446 104.672 34.808 103.172 36.986 103.172L37.292 103.172L37.292 108.278C37.292 111.47 38.786 113.438 41.204 113.438C43.598 113.438 45.194 111.512 45.194 108.62C45.194 105.83 43.712 103.814 41.276 103.172L44.834 103.172L44.834 100.742L36.986 100.742C33.392 100.742 31.244 103.106 31.244 107.024C31.244 110.726 33.17 113.048 36.212 113.048ZM39.332 103.172L39.698 103.172C41.672 103.172 43.076 105.158 43.076 107.966C43.076 109.946 42.38 111.038 41.12 111.038C39.956 111.038 39.332 110.09 39.332 108.302L39.332 103.172ZM44.732 91.1728L42.632 91.1728C42.902 92.1868 43.028 92.9428 43.028 93.5008C43.028 94.9168 42.212 95.5528 40.46 95.5528L33.644 95.5528L33.644 91.1728L31.604 91.1728L31.604 95.5528L28.556 95.5528L28.556 97.9828L31.604 97.9828L31.604 99.7828L33.644 99.7828L33.644 97.9828L40.454 97.9828C43.562 97.9828 45.188 96.5428 45.188 93.9088C45.188 93.1048 45.038 92.1928 44.732 91.1728ZM37.676 87.2691C35 87.2691 33.44 85.8111 33.44 83.3691C33.44 81.1011 34.784 79.9731 37.436 79.9731L44.834 79.9731L44.834 77.5431L37.436 77.5431C33.596 77.5431 31.244 79.3491 31.244 82.3611C31.244 84.8271 32.822 86.6271 35.426 87.2691L27.074 87.2691L27.074 89.6991L44.834 89.6991L44.834 87.2691L37.676 87.2691ZM38.216 76.2234C42.398 76.2234 45.194 73.6314 45.194 69.7554C45.194 65.8794 42.398 63.2874 38.216 63.2874C34.034 63.2874 31.244 65.8794 31.244 69.7554C31.244 73.6314 34.034 76.2234 38.216 76.2234ZM38.216 73.7934C35.264 73.7934 33.44 72.2514 33.44 69.7494C33.44 67.2534 35.258 65.7174 38.216 65.7174C41.174 65.7174 42.998 67.2534 42.998 69.7494C42.998 72.2514 41.174 73.7934 38.216 73.7934ZM37.676 59.4834C35 59.4834 33.44 58.0254 33.44 55.5834C33.44 53.3154 34.784 52.1874 37.436 52.1874L44.834 52.1874L44.834 49.7574L37.436 49.7574C33.596 49.7574 31.244 51.5574 31.244 54.5754C31.244 57.0414 32.822 58.8414 35.426 59.4834L31.604 59.4834L31.604 61.9134L44.834 61.9134L44.834 59.4834L37.676 59.4834ZM27.308 31.8726L27.308 34.1526C29.636 34.1526 30.302 34.7526 30.302 36.5946L30.302 38.1366L32.462 38.1366L32.462 34.3926L42.494 34.3926L42.494 37.4286L44.834 37.4286L44.834 28.8366L42.494 28.8366L42.494 31.8726L27.308 31.8726Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1326_1110",
    x: -148,
    y: -156,
    width: 395,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1326_1110"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 80
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1326_1110",
    result: "effect2_dropShadow_1326_1110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1326_1110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_1110",
    x1: 37.5,
    y1: 0,
    x2: 37.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AB1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB1BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1326_1110",
    x1: -45.5,
    y1: 224,
    x2: 124.5,
    y2: -41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AB1BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AB1BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1326_1110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackathon1);
export default __webpack_public_path__ + "static/media/Hackathon1.65bf5be622e0cdc27c7a1f9d2311f3ff.svg";
export { ForwardRef as ReactComponent };